module.exports = __webpack_public_path__ + "static/media/remove-button.411256ef.svg";